/**
 * The owning network, as list and detail responses carry it. Only interesting
 * when a list spans more than one network — see `listScopeParams` in context.ts.
 */
export interface NetworkRef {
  id: string
  tagId: string
  name: string
}

export function mapNetworkRef(raw: unknown): NetworkRef | undefined {
  if (raw === null || typeof raw !== 'object') return undefined
  const n = raw as Record<string, unknown>
  if (typeof n.id !== 'string') return undefined
  return {
    id: n.id,
    tagId: (n.tagId as string) ?? '',
    name: (n.name as string) ?? '',
  }
}
